import React, { useEffect, useState } from 'react';
import * as api from '../../billMemory/api';
import { shortDate } from '../../billMemory/core';

/** "vendor lessons: Shadow 12 days · 40 greens, 1 wrong" — one source of one business, this week. */
export function sourceLine(s) {
  const days = s.days == null ? '' : ` ${s.days} ${s.days === 1 ? 'day' : 'days'}`;
  return `${s.words || s.source}: ${s.state}${days} · ${s.greens_week} greens, ${s.wrong_week} wrong`;
}

/**
 * Invexis admin — Health (Fix plan, Monitoring): one row per started business, problems first (a wrong green,
 * errors, a step-back, Ready): each source's state and this week's greens, audit rows pending, the last error,
 * "not stock" (I11) and retries waiting.
 */
export default function HealthView() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    Promise.resolve(api.getHealth()).then((r) => setRows((r && r.rows) || [])).catch(() => setRows([]));
  }, []);
  return (
    <section className="bm-panel">
      <h3>Health</h3>
      {!rows && <div className="bm-note">Loading…</div>}
      {rows && !rows.length && <div className="bm-note">No business has started yet.</div>}
      {rows && rows.length > 0 && (
        <table className="irr-qty-table bm-table">
          <thead><tr><th>Business</th><th>Sources this week</th><th>Audit pending</th><th>Last error</th><th>Not stock</th><th>Retries waiting</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.business_id}>
                <td>{r.business_name}</td>
                <td>{(r.sources || []).map((s) => <div key={s.source}>{sourceLine(s)}</div>)}</td>
                <td>{r.audit_pending}</td>
                <td>{r.last_error ? `${shortDate(r.last_error.at)} ${r.last_error.point}` : '—'}</td>
                <td>{r.not_stock ? `${r.not_stock.leftOut} left out, ${r.not_stock.addedBack} added back` : '—'}</td>
                <td>{r.retry_waiting}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
